import { ChatNotificationsModel } from '@klant/conversational-connector/models/ChatNotifications.model';
import { ConversationalChatVisibility } from '@klant/conversational-connector/klant-conversational-connector.model';

import { Injectable } from '@angular/core';

import { ChatNotificaties } from '@ap/interface-apic-conversational-chat';
import { FloatingActionButtonModel } from '@ap/floating-action-button';

/**
 * @module KlantConversationalModule
 * @ngdoc mapper-service
 * @name ConversationalChatMapper
 */
@Injectable({ providedIn: 'root' })
export class ConversationalChatMapper {
    public static mapChatNotificatiesToChatNotificationsModel(chatNotificaties: ChatNotificaties): ChatNotificationsModel {
        return {
            chatNotifications: chatNotificaties.notificaties
        };
    }

    public static mapFloatingActionButtonModelToConversationalChatVisibility(
        status: FloatingActionButtonModel
    ): ConversationalChatVisibility {
        switch (status) {
            case FloatingActionButtonModel.OPEN:
                return ConversationalChatVisibility.OPEN;
            case FloatingActionButtonModel.CLOSED:
                return ConversationalChatVisibility.MINIMIZED;
            default:
                return null;
        }
    }
}
